/** Tracks whether the in-progress signup started from the mini-website modal. */
export const SIGNUP_SOURCE_KEY = 'tcards_signup_source';
export const MINIWEBSITE_SIGNUP_SOURCE = 'miniwebsite';
export const DIGITAL_CARD_SIGNUP_SOURCE = 'digital_card';

/** Set when mini-website modal signup finishes (prevents AuthFlow from resuming template step). */
export const MINIWEBSITE_SIGNUP_COMPLETE_KEY = 'tcards_miniwebsite_signup_complete';

export function markMiniwebsiteSignupSource() {
  try {
    localStorage.setItem(SIGNUP_SOURCE_KEY, MINIWEBSITE_SIGNUP_SOURCE);
  } catch {}
}

export function markDigitalCardSignupSource() {
  try {
    localStorage.setItem(SIGNUP_SOURCE_KEY, DIGITAL_CARD_SIGNUP_SOURCE);
  } catch {}
}

export function clearSignupSourceFlags() {
  try {
    localStorage.removeItem(SIGNUP_SOURCE_KEY);
    localStorage.removeItem(MINIWEBSITE_SIGNUP_COMPLETE_KEY);
    // Legacy key from earlier fix — keep clearing for stale sessions
    localStorage.removeItem('owner_signup_finalized');
  } catch {}
}

export function isMiniwebsiteSignupSource(): boolean {
  try {
    return localStorage.getItem(SIGNUP_SOURCE_KEY) === MINIWEBSITE_SIGNUP_SOURCE;
  } catch {
    return false;
  }
}

export function markMiniwebsiteSignupComplete() {
  try {
    localStorage.setItem(MINIWEBSITE_SIGNUP_COMPLETE_KEY, '1');
    localStorage.removeItem('owner_signup_finalized');
  } catch {}
}

export function isMiniwebsiteSignupComplete(): boolean {
  try {
    return (
      localStorage.getItem(MINIWEBSITE_SIGNUP_COMPLETE_KEY) === '1' ||
      localStorage.getItem('owner_signup_finalized') === '1'
    );
  } catch {
    return false;
  }
}

export function isDigitalCardSignupSource(): boolean {
  try {
    return localStorage.getItem(SIGNUP_SOURCE_KEY) === DIGITAL_CARD_SIGNUP_SOURCE;
  } catch {
    return false;
  }
}

export const DIGITAL_CARD_LANDING_PATH = '/digital-card';

export function getAuthBackHomeUrl(): string {
  if (isDigitalCardSignupSource()) return DIGITAL_CARD_LANDING_PATH;
  return '/';
}

export function getPostSignupRedirectUrl(): string {
  return isMiniwebsiteSignupSource() || isMiniwebsiteSignupComplete()
    ? '/website/dashboard'
    : '/auth?panel=owner&dashboard=1';
}
